import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';

const Button = VideoJS.getComponent('Button');

class ASShareButton extends Button {
    buildCSSClass() {
        return `as-share-button vjs-share-button ${super.buildCSSClass()}`;
    }
}

ASShareButton.prototype.controlText_ = 'Share';

VideoJS.registerComponent(Controls.SHARE_CONTROL, ASShareButton);

export default ASShareButton;



// WEBPACK FOOTER //
// ./src/player/components/ASShareButton.js